import { Node } from './types'

export const makePush = (node: Node): void => {
  node.pushes.forEach(pushedNode => yOffsetChanged(pushedNode))
}

export const getHeightPlusY = (obj: Node): number =>
  obj.heightOffset + obj.originalHeight + obj.originalY + obj.yOffset

export const getHeights = (children: Node[]): number => {
  return children.reduce((previousBiggestHeightPlusY, obj) => {
    const heightPlusY = getHeightPlusY(obj)
    return Math.max(heightPlusY, previousBiggestHeightPlusY)
  }, 0)
}

export const calculateHeightFromChildren = (node: Node): void => {
  const newHeight = getHeights(node.children)
  heightChanged(node, newHeight)
}

export const heightChanged = (node: Node, newHeight: number) => {
  const heightDidntChange =
    node.originalHeight + node.heightOffset === newHeight

  if (heightDidntChange) {
    return
  }

  const lessThanOriginalHeight = node.originalHeight > newHeight
  if (lessThanOriginalHeight) {
    newHeight = node.originalHeight
  }

  node.heightOffset = newHeight - node.originalHeight
  makePush(node)

  if (node.parent) {
    calculateHeightFromChildren(node.parent)
  }
}

export const yOffsetChanged = (node: Node): void => {
  node.yOffset = node.pushedBy.reduce(
    (maxOffset: number, parentNode: Node) =>
      Math.max(maxOffset, parentNode.heightOffset + parentNode.yOffset),
    0
  )
  makePush(node)
}
